"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDEX = exports.DEXS = void 0;
const _1inch_1 = require("./1inch");
const bProtocol_1 = require("./bProtocol");
const mStable_1 = require("./mStable");
const uniswap_v2_1 = require("./uniswap-v2");
const uniswap_v1_1 = require("./uniswap-v1");
const kyber_1 = require("./kyber");
const bancor_1 = require("./bancor");
const zerox_1 = require("./zerox");
const curve_1 = require("./curve");
const curve_v2_1 = require("./curve-v2");
const aave_1 = require("./aave");
const compound_1 = require("./compound");
const weth_1 = require("./weth");
const balancer_1 = require("./balancer");
const shell_1 = require("./shell");
const cofix_1 = require("./cofix");
const dodo_1 = require("./dodo");
const dodov2_1 = require("./dodov2");
const nerve_1 = require("./nerve");
const uniswap_v3_1 = require("./uniswap-v3");
const smoothy_1 = require("./smoothy");
const onebit_1 = require("./onebit");
exports.DEXS = {
    uniswap: uniswap_v1_1.UniswapV1,
    uniswapv2: uniswap_v2_1.UniswapV2,
    sushiswap: uniswap_v2_1.UniswapV2,
    defiswap: uniswap_v2_1.UniswapV2,
    linkswap: uniswap_v2_1.UniswapV2,
    pancakeswap: uniswap_v2_1.UniswapV2,
    pancakeswapv2: uniswap_v2_1.UniswapV2,
    apeswap: uniswap_v2_1.UniswapV2,
    julswap: uniswap_v2_1.UniswapV2,
    streetswap: uniswap_v2_1.UniswapV2,
    bakeryswap: uniswap_v2_1.UniswapV2,
    quickswap: uniswap_v2_1.UniswapV2,
    pantherswap: uniswap_v2_1.UniswapV2,
    mdex: uniswap_v2_1.UniswapV2,
    biswap: uniswap_v2_1.UniswapV2,
    waultfinance: uniswap_v2_1.UniswapV2,
    shibaswap: uniswap_v2_1.UniswapV2,
    coinswap: uniswap_v2_1.UniswapV2,
    sakeswap: uniswap_v2_1.UniswapV2,
    jetswap: uniswap_v2_1.UniswapV2,
    cometh: uniswap_v2_1.UniswapV2,
    dfyn: uniswap_v2_1.UniswapV2,
    kyber: kyber_1.Kyber,
    bancor: bancor_1.Bancor,
    paraswappool: zerox_1.Zerox,
    paraswappool3: zerox_1.Zerox,
    zerox: zerox_1.Zerox,
    curve: curve_1.Curve,
    curve3: curve_1.Curve,
    curvev2: curve_v2_1.CurveV2,
    swerve: curve_1.Curve,
    acryptos: curve_1.Curve,
    ellipsis: curve_1.Curve,
    beltfi: curve_1.Curve,
    aave: aave_1.Aave,
    aave2: aave_1.Aave,
    compound: compound_1.Compound,
    weth: weth_1.Weth,
    wbnb: weth_1.Weth,
    wmatic: weth_1.Weth,
    balancer: balancer_1.Balancer,
    shell: shell_1.Shell,
    cofix: cofix_1.Cofix,
    dodov1: dodo_1.DODO,
    dodov2: dodov2_1.DODOV2,
    nerve: nerve_1.Nerve,
    saddle: nerve_1.Nerve,
    ironv2: nerve_1.Nerve,
    uniswapv3: uniswap_v3_1.UniswapV3,
    smoothy: smoothy_1.Smoothy,
    omm1: onebit_1.OneBit,
    oneinchlp: _1inch_1.OneInch,
    mstable: mStable_1.mStable,
    bprotocol: bProtocol_1.BProtocol,
};
function getDEX(dex) {
    return dex.toLowerCase().match(/^paraswappool(.*)/)
        ? exports.DEXS.paraswappool
        : exports.DEXS[dex.toLowerCase()];
}
exports.getDEX = getDEX;
//# sourceMappingURL=index.js.map